export enum ApiErrors {
  /*
    Occurs in registerAdmin
    Happens if admin password is incorrect
  */
  ADMIN_INVALID_KEY = 'admin_invalid_key',

  /*
    Occurs in createInvestment
    Happens if the sum of the user's total investment amount in the sale and amount of investment being created is bigger than maximum user investment per sale.
  */
  INVEST_TOTAL_USER_INVESTMENT_IN_SALE_EXCEEDS_MAX = 'invest_total_user_investment_in_sale_exceeds_max',

  /*
    Occurs in createInvestment
    Happens if desired amount exceeds maximum amount per investment.
  */
  INVEST_AMOUNT_EXCEEDS_MAXIMAL = 'invest_amount_exceeds_max',

  /*
    Occurs in createInvestment
    Happens if desired amount exceeds amount of remining shares.
  */
  INVEST_AMOUNT_EXCEEDS_SHARES = 'invest_amount_exceeds_shares',

  /*
    Occurs in createInvestment
    Happens if desired amount is lower than minimum amount per investment.
  */
  INVEST_AMOUNT_LOWER_MINIMAL = 'invest_amount_lower_min',

  /*
    Occurs in updateInvestment
    Happens if investment status isn't correct
  */
  INVEST_INVALID_STATUS = 'invest_invalid_status',

  /*
    Occurs in createInvestment, updateInvestment
    Happens if investment status isn't correct
  */
  INVEST_NO_ACTIVE_USER_WALLET = 'invest_no_active_user_wallet',

  /*
    Occurs in createInvestment
    Happens if sale volume is bigger than 1M and sum of the user's total investment amount in the sale and amount of investment being created is bigger than 1K
  */
  INVEST_SELF_DISCLOSURE_NEEDED = 'invest_self_discolure_needed',

  /*
    Occurs in updateInvestment
    Happens if investment is older than 14 days
  */
  INVEST_TOO_OLD = 'invest_too_old',

  /*
    Happens if user idNowStatus is not NEEDS_APPROVAL
    Occurs in approveUser mutation
  */
  USER_APPROVAL_NOT_NEEDED = 'user_approval_not_needed',

  /*
    Occurs in registerUser & registerAdmin mutation
    Happens if provided email is already used.
  */
  USER_DUPLICATE_EMAIL = 'user_duplicate_email',

  /*
    Happens if (idDocumentType, idDocumentNumber, idDocumentCountry) triple is already used
    Occurs in updateUser mutation
  */
  USER_DUPLICATE_IDENTIFICATION = 'user_duplicate_identification',

  /*
    Occurs in signDocument
    Happens if user in database has no firstName and/or lastName
  */
  USER_FULL_NAME_MISSING = 'user_full_name_missing',

  /*
    Occurs in signDocument mutation
    Happens if provided document type does not exist
  */
  USER_INVALID_DOCUMENT_TYPE = 'user_invalid_document_type',

  /*
    Occurs in updateUser mutation
    Happens if one of (idDocumentType, idDocumentNumber, idDocumentCountry) triple is provided but one of it is missing
  */
  USER_MISSING_IDENTIFICATION_DATA = 'user_missing_identification_data',

  /*
    Occurs in startIdNow mutation
    Happens if at least one of the required field for idNow is missing
  */
  USER_MISSING_IDNOW_DATA = 'user_missing_idnow_data',

  /*
    Occurs in user.addInvestment mutation
    Happens if at least one of the required field for user in general is missing
  */
  USER_MISSING_REQUIRED_DATA = 'user_missing_required_data',

  /*
    Occurs in updateUser mutation
    Happens if provided field already set in user record
  */
  USER_FIELDS_ALREADY_CREATED = 'user_fields_already_created',

  /*
    Occurs in startIdNow mutation
    Happens if idNowStatus is not undefined
  */
  USER_IDNOW_ALREADY_INITIATED = 'user_idnow_already_initiated',

  /*
    Occurs in loginUser
    Happens if there is no user found by provided credentials
  */
  USER_INVALID_CREDENTIALS = 'user_invalid_credentials',

  /*
    Occurs in addInvestment
    Happens if user is not IDNow confirmed
  */
  USER_INVALID_IDNOWSTATUS = 'user_invalid_idnowstatus',

  /*
    User wasn't found
    Occurs in getCurrendUser query
  */
  USER_NOT_FOUND = 'user_not_found',

  /*
    Occurs in deletePayment
    Happens if user is trying to remove default payment method
  */
  USER_PAYMENT_METHOD_DEFAULT = 'user_payment_method_default',

  /*
    Occurs in deletePayment, addInvestment and updateUser
    deletePayment - Happens if payment method wasn't found by provided id
    addInvestment - Happens if payment method wasn't found by provided id
    updateUser - Happens if default payment method isn't in payment_methods
  */
  USER_PAYMENT_METHOD_NOT_FOUND = 'user_payment_method_not_found',

  /*
    Occurs in updateUser mutation
    Happens if user's wallet already exists
  */
  USER_WALLET_ALREADY_CREATED = 'user_wallet_already_created',

  /*
    Occurs in createSale
    Happens if:
    - start date is in past or
    - end date is in past or
    - end date is before start date
  */
  SALE_DATE_RANGE_INVALID = 'sale_date_range_invalid',

  /*
    Occurs in createSale
    Happens if provided fileId (s3 object key) wasn't found in s3 bucket
  */
  SALE_FILE_NOT_FOUND = 'sale_file_not_found',

  /*
    Occurs in createSale
    Happens if provided file.mimeType is not allowed for images or for documents
  */
  SALE_DISALLOWED_MIME_TYPE = 'sale_disallowed_mime_type',

  /*
    Occurs in createSale
    Happens if provided investmentClass is not supported
  */
  SALE_INVESTMENT_CLASS_NOT_SUPPORTED = 'sale_investment_class_not_supproted',

  /*
    Occurs in updateSale
    Happens if sale status isn't correct
  */
  SALE_INVALID_STATUS = 'sale_invalid_status',

  /*
    Occurs in createSale
    Happens if provided name is already used
  */
  SALE_NAME_TAKEN = 'sale_name_taken',

  /*
    Occurs in deleteSale
    Happens if trying to delete non-existing sale
  */
  SALE_NOT_FOUND = 'sale_not_found',

  /*
    Occurs in sale.addInvestment
    Happens if trying to invest in non-active sale
  */
  SALE_NOT_ACTIVE = 'sale_not_active',

  /*
    Occurs in createSale, updateInvestment
    Happens if:
    - sale token's creation failed
    - sale token's minting failed
    - sale token's burning failed
  */
  TOKEN_OPERATION_FAILED = 'token_operation_failed',

  /*
    Occurs in updateUser
    Happens if:
    - field is not updatable
    - fiels is updatable before verification started but verification already started
  */
  UPDATABILITY_FAILED = 'updatability_failed',

  /*
    Occurs in createSale
    Happens if:
    - corePropertyRepresentations array does not include all core property fields
  */
  SALE_CORE_PROPERTY_MISSING_FIELD = 'sale_core_property_missing_field',

  /*
    Occurs in createSale
    Happens if:
    - corePropertyRepresentations array include duplicate core property fields
  */
    SALE_CORE_PROPERTY_DUPLICATE_FIELD = 'sale_core_property_duplicate_field',
}
